/* Popup "ha appena acquistato" di Creazioni Fadal (sostituisce l'app ONE / Proof Factor).
   Dati: /collections/all?view=fadal-vendite (template collection.fadal-vendite.liquid). */
(function () {
  if (/^\/(cart|checkout|checkouts|account)/.test(location.pathname)) return;

  var CACHE = 'frSales', OFF = 'frSalesOff';
  var MAX_DAYS = 60, FIRST_DELAY = 7000, VISIBLE = 6500, GAP = 18000, PER_VISIT = 4;

  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  if (store(OFF)) return;

  function title(s) {
    return (s || '').trim().toLowerCase().replace(/(^|[\s'’-])(\S)/g, function (m, a, b) { return a + b.toUpperCase(); })
      .replace(/ (Del|Della|Di|Sul|Sulla|In|Al|Alla|Dei|Delle) /g, function (m) { return m.toLowerCase(); });
  }

  function ago(t) {
    var min = (Date.now() - t) / 60000;
    if (min < 60) return min < 5 ? 'pochi minuti fa' : Math.round(min) + ' minuti fa';
    var h = Math.round(min / 60);
    if (h < 24) return h === 1 ? '1 ora fa' : h + ' ore fa';
    var d = Math.floor(min / 1440);
    if (d === 1) return 'ieri';
    if (d < 7) return d + ' giorni fa';
    var w = Math.floor(d / 7);
    return w === 1 ? '1 settimana fa' : w + ' settimane fa';
  }

  function esc(s) { var el = document.createElement('span'); el.textContent = s; return el.innerHTML; }

  function load(cb) {
    try {
      var c = JSON.parse(store(CACHE));
      if (c && Date.now() - c.at < 600000) return cb(c.d);
    } catch (e) {}
    fetch('/collections/all?view=fadal-vendite', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { store(CACHE, JSON.stringify({ at: Date.now(), d: d })); cb(d); })
      .catch(function () {});
  }

  function sales(raw) {
    var seen = {}, out = [];
    (raw || []).forEach(function (x) {
      var p = (x.v || '').split('|'), when = Date.parse(p[2]);
      if (!when || Date.now() - when > MAX_DAYS * 864e5 || when > Date.now() + 36e5) return;
      var key = x.u + '|' + Math.round(when / 6e4);
      if (seen[key]) return;
      seen[key] = 1;
      out.push({ name: title(p[0]), city: title(p[1]), when: when, title: x.t, url: x.u, img: x.i });
    });
    return out.sort(function (a, b) { return b.when - a.when; }).slice(0, 10);
  }

  var box = null;
  function hide() {
    if (!box) return;
    box.classList.remove('fr-sale-in');
    var old = box; box = null;
    setTimeout(function () { old.remove(); }, 400);
  }

  function show(s) {
    hide();
    var who = s.name && s.city ? s.name + ' da ' + s.city : (s.name || (s.city ? 'Un cliente da ' + s.city : 'Un cliente'));
    box = document.createElement('div');
    box.className = 'fr-sale';
    box.setAttribute('role', 'status');
    box.innerHTML =
      '<a class="fr-sale-link" href="' + esc(s.url) + '">' +
      (s.img ? '<img src="' + esc(s.img) + '" alt="" width="56" height="56" loading="lazy">' : '') +
      '<span class="fr-sale-txt"><strong>' + esc(who) + '</strong> ha acquistato ' +
      '<span class="fr-sale-prod">' + esc(s.title) + '</span>' +
      '<span class="fr-sale-meta">' + ago(s.when) + ' · <span class="fr-sale-ok">Acquisto verificato</span></span></span></a>' +
      '<button type="button" class="fr-sale-x" aria-label="Chiudi">&times;</button>';
    box.querySelector('.fr-sale-x').addEventListener('click', function () { store(OFF, '1'); hide(); });
    document.body.appendChild(box);
    requestAnimationFrame(function () { box && box.classList.add('fr-sale-in'); });
  }

  // finché il banner dei cookie di Shopify è aperto il popup aspetta, così non si sovrappongono
  function cookieBannerOpen() {
    var els = [document.getElementById('shopify-pc__banner'), document.getElementById('shopify-pc__prefs__dialog')];
    return els.some(function (el) {
      if (!el) return false;
      var cs = getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && el.getBoundingClientRect().height > 0;
    });
  }

  load(function (raw) {
    var list = sales(raw);
    if (!list.length) return;
    var i = 0;
    function next() {
      if (store(OFF) || i >= Math.min(PER_VISIT, list.length)) return;
      if (cookieBannerOpen()) { setTimeout(next, 4000); return; }
      show(list[i++]);
      setTimeout(hide, VISIBLE);
      setTimeout(next, VISIBLE + GAP);
    }
    setTimeout(next, FIRST_DELAY);
  });
})();
